module.exports = __webpack_public_path__ + "img/tips.150ca9f6.png";